// Maps cookbook slug -> raw markdown string. Bodies are imported via webpack's
// `asset/source` rule (see craco.config.js). Empty entries fall through to a
// "Coming soon" placeholder in the detail page.
import voiceAgentQuickstart from "./cookbooks/voice-agent-quickstart.md";
import chatAgentMemory from "./cookbooks/chat-agent-persistent-memory.md";
import multiAgentWorkflow from "./cookbooks/multi-agent-agentos-workflow.md";
import ragFromScratch from "./cookbooks/rag-system-from-scratch.md";

export const COOKBOOK_BODIES = {
  "voice-agent-quickstart": voiceAgentQuickstart,
  "chat-agent-persistent-memory": chatAgentMemory,
  "multi-agent-agentos-workflow": multiAgentWorkflow,
  "rag-system-from-scratch": ragFromScratch,
};
